// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Sidebar wrapper ───────────────────────────────────────── */
.scl--cms-components-notifSidebar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  width: 100%;
  height: 100%;
}

/* ── Header ────────────────────────────────────────────────── */
.scl--cms-components-notifSidebar-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 9px 18px;
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  flex-shrink: 0;
}

/* ── Header Title ──────────────────────────────────────────── */
.scl--cms-components-notifSidebar-headerTitle {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #070707;
}

/* ── See More Button ───────────────────────────────────────── */
.scl--cms-components-notifSidebar-seeMore {
  background: none;
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  color: #2388FF;
  transition: background 0.15s ease, color 0.15s ease;
}

.scl--cms-components-notifSidebar-seeMore:hover {
  text-decoration: underline;
}

/* ── List ──────────────────────────────────────────────────── */
.scl--cms-components-notifSidebar-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  flex: 1;
  overflow-y: auto;
}

/* ── Row ───────────────────────────────────────────────────── */
.scl--cms-components-notifSidebar-row {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 24px;
  width: 100%;
  min-height: 92px;
  border-bottom: 1px solid #E5E5E7;
  background: #FFFFFF;
  transition: background 0.15s ease;
}

.scl--cms-components-notifSidebar-row:hover {
  background: #EFF3F880;
}

.scl--cms-components-notifSidebar-row:last-child {
  border-bottom: none;
}

/* ── Text block ────────────────────────────────────────────── */
.scl--cms-components-notifSidebar-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  gap: 5px;
  flex: 1;
  min-width: 0;
}

/* ── Title ─────────────────────────────────────────────────── */
.scl--cms-components-notifSidebar-title {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #111927;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scl--cms-components-notifSidebar-title::first-letter{
  text-transform: uppercase;
}

.scl--cms-components-notifSidebar-title:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* ── Body ──────────────────────────────────────────────────── */
.scl--cms-components-notifSidebar-body {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #858C95;
  margin: 0;
  width: 100%;
  display: -webkit-box;
  -webkit-lineClamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Empty state ───────────────────────────────────────────── */
.scl--cms-components-notifSidebar-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 24px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #9095A1;
  box-sizing: border-box;
}

/* ── Unread row ───────────────────────────────────────────── */

.scl--cms-components-notifSidebar-row--unread {
  background: var(--primarypalette-blue-50, #EFF6FF);
  border-left: 3px solid var(--primarypalette-blue, #2388FF);
}

.scl--cms-components-notifSidebar-row--unread:hover {
  background: var(--primarypalette-blue-100, #DBEAFE);
}

/* ── Unread title ─────────────────────────────────────────── */

.scl--cms-components-notifSidebar-title--unread {
  font-weight: 600;
  color: var(--typography-text-body-primary);
}

/* ── Unread dot ───────────────────────────────────────────── */

.scl--cms-components-notifSidebar-unreadDot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--primarypalette-blue, #2388FF);
  flex-shrink: 0;
  align-self: center;
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/right-sidebar-fs-cp/rs-notification-op/notification-sidebar/css/notificationSidebar.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,OAAO;EACP,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;EACV,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,gEAAgE;;AAEhE;EACE,kDAAkD;EAClD,0DAA0D;AAC5D;;AAEA;EACE,mDAAmD;AACrD;;AAEA,gEAAgE;;AAEhE;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,gEAAgE;;AAEhE;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":["/* ── Sidebar wrapper ───────────────────────────────────────── */\n.scl--cms-components-notifSidebar {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n}\n\n/* ── Header ────────────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 9px 18px;\n  width: 100%;\n  height: 50px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n/* ── Header Title ──────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-headerTitle {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 24px;\n  color: #070707;\n}\n\n/* ── See More Button ───────────────────────────────────────── */\n.scl--cms-components-notifSidebar-seeMore {\n  background: none;\n  border: none;\n  padding: 4px 8px;\n  cursor: pointer;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 20px;\n  color: #2388FF;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.scl--cms-components-notifSidebar-seeMore:hover {\n  text-decoration: underline;\n}\n\n/* ── List ──────────────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-list {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n  flex: 1;\n  overflow-y: auto;\n}\n\n/* ── Row ───────────────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-row {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 24px;\n  width: 100%;\n  min-height: 92px;\n  border-bottom: 1px solid #E5E5E7;\n  background: #FFFFFF;\n  transition: background 0.15s ease;\n}\n\n.scl--cms-components-notifSidebar-row:hover {\n  background: #EFF3F880;\n}\n\n.scl--cms-components-notifSidebar-row:last-child {\n  border-bottom: none;\n}\n\n/* ── Text block ────────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0;\n  gap: 5px;\n  flex: 1;\n  min-width: 0;\n}\n\n/* ── Title ─────────────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-title {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #111927;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.scl--cms-components-notifSidebar-title::first-letter{\n  text-transform: uppercase;\n}\n\n.scl--cms-components-notifSidebar-title:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* ── Body ──────────────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-body {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #858C95;\n  margin: 0;\n  width: 100%;\n  display: -webkit-box;\n  -webkit-lineClamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ── Empty state ───────────────────────────────────────────── */\n.scl--cms-components-notifSidebar-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 48px 24px;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  color: #9095A1;\n  box-sizing: border-box;\n}\n\n/* ── Unread row ───────────────────────────────────────────── */\n\n.scl--cms-components-notifSidebar-row--unread {\n  background: var(--primarypalette-blue-50, #EFF6FF);\n  border-left: 3px solid var(--primarypalette-blue, #2388FF);\n}\n\n.scl--cms-components-notifSidebar-row--unread:hover {\n  background: var(--primarypalette-blue-100, #DBEAFE);\n}\n\n/* ── Unread title ─────────────────────────────────────────── */\n\n.scl--cms-components-notifSidebar-title--unread {\n  font-weight: 600;\n  color: var(--typography-text-body-primary);\n}\n\n/* ── Unread dot ───────────────────────────────────────────── */\n\n.scl--cms-components-notifSidebar-unreadDot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--primarypalette-blue, #2388FF);\n  flex-shrink: 0;\n  align-self: center;\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
